import { isInAppBrowser } from '@utils/isInAppBrowser';
import { useEffect, useState } from 'react';

export default function EscapeWebViewBanner({ children }) {
  const [showBanner, setShowBanner] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (isInAppBrowser()) {
      setShowBanner(true);
    }
  }, []);

  if (!showBanner) return <>{children}</>;

  const handleOpenInBrowser = () => {
    const link = document.createElement('a');
    link.href = window.location.href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000); // Reset text after 3s
  };
  const inAppName =
    navigator.userAgent.match(
      /(LinkedInApp|Instagram|FBAN|FBAV|FB_IAB|Snapchat|Pinterest|Twitter|WhatsApp|Messenger)/i,
    )?.[0] || 'an in-app browser';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: '#f3efff',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
      }}
    >
      <h2
        style={{
          fontSize: '1.875rem',
          fontWeight: 'bold',
          color: '#1f2937',
          marginBottom: '1rem',
        }}
      >
        Please open in your browser
      </h2>

      <p
        style={{
          textAlign: 'center',
          fontSize: '1.125rem',
          color: '#374151',
          maxWidth: '28rem',
        }}
      >
        It looks like you’re viewing this inside{' '}
        <span style={{ fontWeight: 600, color: '#4f46e5' }}>{inAppName}</span>
        .
        <br />
        For full functionality (login, cookies, file downloads, share sheets), tap below.
      </p>

      <button
        onClick={handleOpenInBrowser}
        style={{
          marginTop: '1.5rem',
          padding: '0.75rem 2rem',
          fontSize: '1rem',
          fontWeight: 600,
          color: '#ffffff',
          background: 'linear-gradient(to bottom right, #7d5ae8, #6443c8ff)',
          border: 'none',
          borderRadius: '1rem',
          boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
          cursor: 'pointer',
          transition: 'transform 0.3s, box-shadow 0.3s',
          textAlign: 'center',
          textDecoration: 'none',
          display: 'inline-block',
        }}
        onKeyPress={handleOpenInBrowser}
        tabIndex={0}
        aria-label="Open in Browser"
      >
        Open in Browser
      </button>

      <button
        onClick={handleCopyLink}
        aria-label="Copy Link"
        style={{
          marginTop: '0.75rem',
          display: 'inline-block',
          padding: '0.5rem 1.5rem',
          fontSize: '1rem',
          fontWeight: 500,
          color: '#2563eb',
          backgroundColor: '#ffffff',
          border: '1px solid #bfdbfe',
          borderRadius: '0.75rem',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
      >
        {copied ? 'Copied!' : 'Copy Link'}
      </button>
    </div>
  );
}
